module.exports = __webpack_public_path__ + "static/brightteddyhamper-5c1987d3b85e8a78110f643219a442ae.jpeg";